import React, { useState, useEffect, useRef } from 'react';
import { motion, useAnimation } from 'framer-motion';
import { useSelector, useDispatch } from 'react-redux';

// import actions
import { releaseActivityCardFocus } from 'js/store/app/App.actions';

// import components
import ButtonBackArrow from 'js/components/button/Button.back-arrow';

// import icon
import IconShapes from 'js/components/icon/Icon.shapes';

const HeaderFixed = ({ title = '', additionalText = '', backgroundColor = '#fff', buttonBackAction = false }) => {
  const dispatch = useDispatch();
  const [scrollY, setScrollY] = useState(0);
  const controls = useAnimation();
  const headerRef = useRef(null);
  const [fullHeight, setFullHeight] = useState(0);
  const [collapsed, setCollapsed] = useState(false);

  const activityCardFocus = useSelector((state) => state.app.activityCardFocus);

  const handleScroll = () => setScrollY(window.scrollY);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (headerRef.current) {
      setFullHeight(headerRef.current.getBoundingClientRect().height);
    }
  }, []);

  const collapseCheck = () => {
    if (scrollY > fullHeight / 2) {
      setCollapsed(true);
      controls.start({
        height: 80,
        padding: '15px',
        transition: { duration: 0.5 },
      });
    } else {
      setCollapsed(false);
      controls.start({
        height: fullHeight,
        padding: '55px 15px 20px',
        transition: { duration: 0.5 },
      });
    }
  };

  useEffect(() => {
    if (activityCardFocus) return;

    collapseCheck();
  }, [scrollY, controls, fullHeight]);

  useEffect(() => {
    if (fullHeight == 0) return;
    if (activityCardFocus) {
      setCollapsed(true);

      controls.start({
        height: 80,
        padding: '15px',
        transition: { duration: 0.5 },
      });
    } else {
      collapseCheck();
    }
  }, [activityCardFocus]);

  return (
    <>
      <div style={{ height: (fullHeight || 100) - 40 }}></div>
      <motion.header ref={headerRef} animate={controls} className="header--fixed" style={{ backgroundColor }}>
        <IconShapes className="icon-shapes" />
        {buttonBackAction && (
          <ButtonBackArrow
            action={() => {
              !activityCardFocus && buttonBackAction();
              activityCardFocus && dispatch(releaseActivityCardFocus(true));
            }}
          />
        )}
        <motion.h1
          animate={{
            left: collapsed ? '50%' : 0,
            width: collapsed ? '400px' : '660px',
            maxWidth: collapsed ? '80%' : '100%',
          }}
          initial={{ left: 0, width: '660px' }}
          className={collapsed ? 'truncate' : ''}
          style={{
            position: 'relative',
            transform: collapsed ? 'translateX(-50%)' : 'translateX(0)',
            left: 0,
            width: '660px',
          }}
          transition={{ type: 'spring', stiffness: 300, damping: 30, duration: 1 }}
        >
          {title}
        </motion.h1>
        {additionalText && (
          <motion.p
            animate={{ opacity: collapsed ? 0 : 1, width: '100%' }}
            initial={{ opacity: 1, width: '100%' }}
            transition={{ duration: 0.2 }}
          >
            {additionalText}
          </motion.p>
        )}
      </motion.header>
    </>
  );
};

export default HeaderFixed;
